<template>
  <div style="background-color: #eeeeee; padding-bottom: 100px">
    <img style="display: block; margin: 0 auto" src="../../assets/banner3.png" alt="" />
    <div class="main">
      <ul class="Breadcrumb">
        <li @click="backPage('/home')">首页</li>
        <li>></li>
        <li @click="backPage('-1')">产品中心</li>
        <li>></li>
        <li>{{ proDetail.name }}</li>
      </ul>
      <div class="content">
        <div class="top">
          <div class="fleft">
            <div style="overflow: hidden">
              <h3 class="tab_title title">{{ proDetail.name }}</h3>
              <ul>
                <li v-if="proDetail.status">
                  <img src="../../assets/icon14.png" alt="" />
                  {{ getDictLabel(statusDict,proDetail.status) }} 
                  {{ proDetail.status }}
                </li>
                <li v-if="proDetail.level">
                  <img src="../../assets/icon14.png" alt="" />
                  {{ proDetail.level }}
                </li>
              </ul>
            </div>
            <p style="line-height:32px">{{ proDetail.description }}</p>
          </div>
          <span
            v-if="proDetail.sheet"
            class="download"
            style="cursor: pointer"
            @click="download(proDetail.sheet)"
            ><a href="javascript:void(0);">数据手册</a></span
          >
        </div>
      </div>
    </div>
    <div class="center">
      <div class="nav">
        <div class="main">
          <ul class="nav_ul">
            <li @click="navActive = 1" :class="navActive == 1 ? 'active' : ''">
              产品信息
            </li>
            <!-- <li @click="navActive = 2" :class="navActive == 2 ? 'active' : ''">技术文档</li> -->
          </ul>
        </div>
      </div>
      <div v-show="navActive == 1" class="main container">
        <div style="padding: 30px">
          <ul ref="nav" class="nav_id">
            <li @click="jumpTo(0, '#id1', 'id1')" :class="active == 0 ? 'active' : ''">
              概述
            </li>
            <li @click="jumpTo(1, '#id2')" :class="active == 1 ? 'active' : ''">
              产品视频
            </li>
            <li @click="jumpTo(2, '#id3')" :class="active == 2 ? 'active' : ''">特性</li>
            <li @click="jumpTo(3, '#id4')" :class="active == 3 ? 'active' : ''">应用</li>
            <li @click="jumpTo(4, '#id5')" :class="active == 4 ? 'active' : ''">
              订购信息
            </li>
            <li @click="jumpTo(5, '#id6')" :class="active == 5 ? 'active' : ''">
              销售咨询
            </li>
          </ul>
          <div style="padding-top: 220px; margin-top: -220px" id="id1">
            <h3 class="h3_title"><span>概述</span></h3>
            <div class="ql-editor" v-html="proDetail.overview"></div>
          </div>
          <div style="padding-top: 220px; margin-top: -220px" id="id2">
            <h3 class="h3_title"><span>产品视频</span></h3>
            <div
              @click="checkViedo(item)"
              v-for="(item, index) in videoList"
              class="video"
            >
              <div><img :src="item.coverImage" alt="" /></div>
              <div>
                <p>{{ item.name }}</p>
                <div
                  style="padding-left: 0"
                  class="ql-editor"
                  v-html="item.description"
                ></div>
              </div>
            </div>
          </div>
          <div style="padding-top: 220px; margin-top: -220px" id="id3">
            <h3 class="h3_title"><span>特性</span></h3>
            <div class="ql-editor" v-html="proDetail.feature"></div>
          </div>
          <div style="padding-top: 220px; margin-top: -220px" id="id4">
            <h3 class="h3_title"><span>应用</span></h3>
            <div class="ql-editor" v-html="proDetail.claim"></div>
          </div>
          <div style="padding-top: 220px; margin-top: -220px" id="id5">
            <h3 class="h3_title"><span>订购信息</span></h3>
            <div style="padding: 0 30px">
              <table border="1" cellpadding="0">
                <tr>
                  <th v-for="(item, index) in orderDate">{{ item.colName }}</th>
                </tr>
                <!-- <tr v-for="(item, index) in rows">
                  <td v-for="(i, ind) in orderDate">
                  {{item[i.id].value}}
                  </td>
                </tr> -->
                <tr v-for="(item, index) in orderProductDate">
                  <td v-for="(i, ind) in orderDate" :rowspan="(isValidUrl(item[i.id].value)&&index==0)?orderProductDate2.length:1" >
                    <el-button
                      type="primary"
                      size="mini"
                      v-if="isValidUrl(item[i.id].value)"
                      style="cursor: pointer"
                      @click="goOtherPath(item[i.id].value)"
                      >{{ orderDate[ind].colName }}</el-button
                    >
                    <p v-else>{{item[i.id].value}}</p>
                  </td>
                </tr>
                <tr v-for="(item, index) in orderProductDate1">
                  <td v-for="(i, ind) in orderDate" v-if="!isValidUrl(item[i.id].value)">
                    <el-button
                      type="primary"
                      size="mini"
                      v-if="isValidUrl(item[i.id].value)"
                      style="cursor: pointer"
                      @click="goOtherPath(item[i.id].value)"
                      >{{ orderDate[ind].colName }}</el-button
                    >
                    <p v-else>{{item[i.id].value}}</p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div style="padding-top: 220px; margin-top: -220px" id="id6">
            <h3 class="h3_title"><span>销售咨询</span></h3>
            <div style="padding: 0 30px">
              <table border="1" cellpadding="0">
                <tr>
                  <th>地区</th>
                  <th>电话</th>
                  <th>微信</th>
                  <th>邮箱</th>
                </tr>
                <tr v-for="(item, index) in salers">
                  <td>{{ item.area }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.wx }}</td>
                  <td>{{ item.email }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="main container" v-show="navActive == 2">
                <div style="padding:30px">
                    <table border="1" cellpadding="0">
                        <tr>
                            <th>类型</th>
                            <th>标题</th>
                            <th>下载</th>
                            <th>日期</th>
                        </tr>
                        <tr v-for="(item, index) in files">
                            <td>{{ getDictLabel(typeList,item.type) }}</td>
                            <td>{{ item.name }}</td>
                            <td><span style="cursor: pointer;" @click="download(item.file)">下载</span></td>
                            <td>{{ item.createTime }}</td>
                        </tr>
                    </table>
                </div>
            </div> -->
    </div>
  </div>
</template>
<script>
import { getDictLabel,isValidUrl } from "../../utils/common";

import {
  getProductDetail,
  getDictList,
  getProductSales,
  getProductManuals,
  downloadFile,
  getProductVideoList,
  getProductOrderList,
  getProductOrderTable,
} from "../../api/index";

import "quill/dist/quill.snow.css";
export default {
  data() {
    return {
      id: "",
      type: "工业自动化",
      name: "",
      content: "",
      active: "",
      proDetail: {},
      navActive: 1,
      salers: [],
      files: [],
      statusDict: [],
      active: 0,
      videoList: [],
      showVideo: false,
      videoUrl: "",
      typeList: [],
      orderProductDate: [],
      orderDate: [],
      orderProductDate1:[],
      orderProductDate2:[],
      rows:[]
    };
  },
  methods: {
    goOtherPath(url) {
      if (isValidUrl(url)) {
        const link = document.createElement("a");
        link.target = "_blank";
        // const blob = new Blob([res],{
        //     type:code
        // })
        // const objUrl = URL.createObjectURL(blob)
        link.href = url;
        link.click();
      }
    },
    backPage(page) {
      if (page == "-1") {
        this.$router.go(-1);
      } else {
        this.$router.push(page);
      }
    },
    checkViedo(item) {
      this.$router.push({ path: "/productVideo", query: { id: item.id } });
      document.documentElement.scrollTop = 0;
    },
    jumpTo(active, id, ref) {
      this.active = active;
      // console.log(this.$refs[ref].offset);
      document.querySelector(id).scrollIntoView(true);
    },
    download(url) {
      console.log(url);
      // console.log(res);
      const link = document.createElement("a");
      link.target = "_blank";
      // const blob = new Blob([res],{
      //     type:code
      // })
      // const objUrl = URL.createObjectURL(blob)
      link.href = url;
      link.download = "test";
      link.click();
      const type = url.substring(url.lastIndexOf(".")[1]);
      let code;
      switch (type) {
        case "doc":
          code = "application/msword";
          break;
        case "docx":
          code =
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          break;
        case "pdf":
          code = "application/pdf";
          break;
        case "ppt":
          code = "application/vnd.ms-powerpoint";
          break;
        case "pptx":
          code =
            "application/vnd.openxmlformats-officedocument.presentationml.presentation";
          break;
        case "rar":
          code = "application/x-rar-compressed";
          break;
        case "xls":
          code = "application/vnd.ms-excel";
          break;
        case "xlsx":
          code = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          break;
        case "zip":
          code = "application/zip";
          break;
        case "txt":
          code = "text/plain";
          break;
        default:
          break;
      }
      let params = {
        resource: "http://api.cimomicro.com" + url,
      };
      // downloadFile(params).then(res =>{
      //     console.log(res);
      //     const link = document.createElement('a')
      //     const blob = new Blob([res],{
      //         type:code
      //     })
      //     const objUrl = URL.createObjectURL(blob)
      //     link.href = objUrl
      //     link.download = 'test'
      //     link.click()
      // })
    },
    getDictLabel,
    isValidUrl,
  },
  mounted() {
    this.active = 0;
    this.id = this.$route.query.id;

    getProductDetail(this.id).then((res) => {
      this.proDetail = res.data;
      getDictList("cms_product_status").then((res1) => {
        this.proDetail.status = getDictLabel(res1.data, res.data.status);
      });
      getDictList("cms_product_level").then((res1) => {
        this.proDetail.level = getDictLabel(res1.data, res.data.level);
      });
      getDictList("cms_file_type").then((res1) => {
        this.typeList = res1.data;
      });
    });
    getProductVideoList({ productId: this.id }).then((res) => {
      this.videoList = res.rows;
    });
    let params = {
      productId: this.id,
    };
    getProductManuals(params).then((res) => {
      this.files = res.rows;
    });
    getProductSales(params).then((res) => {
      this.salers = res.rows;
    });
    getProductOrderTable().then((res) => {
      this.orderDate = res.data;
    });
    getProductOrderList({ productId: this.id }).then((res) => {
      let data = res.data;
      let list = [];
      for (let i = 0; i < data.length; i++) {
        let params = { ...data[i].colList, dataId: data[i].dataId };
        list.push(data[i].colList);
      }
      const dataList = res.data;
      let rows = [];
      for (let i = 0; i < dataList.length; i++) {
        const colList = dataList[i].colList;
        let obj = { dataId: dataList[i].dataId };
        for (let j = 0; j < colList.length; j++) {
          obj[colList[j].colId] = { id: colList[j].id, value: colList[j].colValue };
        }
        rows.push(obj);
      }
      console.log(rows);
      this.rows = rows
      this.orderProductDate = [rows[0]];
      this.orderProductDate2 = rows;
      this.orderProductDate1 = rows.slice(1,list.length);

    });
    let _this = this;
    window.onscroll = function () {
      let pageYOffset = window.pageYOffset;
      if (pageYOffset >= 337) {
        _this.$refs.nav.style.position = "fixed";
        _this.$refs.nav.style.top = "78px";
      } else {
        _this.$refs.nav.style.position = "";
      }
    };
  },
};
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  position: relative;
  .menu {
    width: 250px;
  }
}

.title {
  margin-bottom: 30px;
  display: inline-block;
  float: left;
  margin-right: 60px;
}

.top {
  width: 100%;
  overflow: hidden;
  margin-bottom: 30px;
  position: relative;
  .fleft {
    width: 1000px;
  }
  ul {
    display: inline-block;
    float: left;
    margin-top: 4px;
    li {
      margin-bottom: 10px;
      line-height: 18px;
      float: left;
      margin-right: 20px;
    }

    img {
      width: 18px;
      float: left;
      margin-right: 10px;
    }
  }

  span {
    display: block;
    float: right;
    background: url("../../assets/icon15.png") no-repeat;
    padding-left: 50px;
    width: 142px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-size: contain;
    a {
      display: block;
      width: 95px;
      height: 40px;
      font-size: 16px;
      color: #fff;
      background-color: #7f7f7f;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      float: right;
    }
  }
}

.nav {
  background-color: #cfcfcf;
  height: 50px;
}

.nav_ul {
  li {
    font-size: 22px;
    width: 160px;
    text-align: center;
    float: left;
    line-height: 50px;
    cursor: pointer;
  }

  li.active {
    background-color: #fff;
    font-weight: bold;
  }
}

.container {
  background-color: #fff;

  .nav_id {
    overflow: hidden;
    background-color: #fff;
    width: 1200px;
    z-index: 9;
    border-bottom: 1px solid #7e7e7e;
    margin-left: -30px;
    li {
      float: left;
      color: #7e7e7e;
      padding: 0 30px;
      font-size: 20px;
      line-height: 60px;
      cursor: pointer;
    }

    .active {
      font-weight: bold;
      color: #2e2e2e;
    }
  }

  .h3_title {
    font-size: 18px;
    padding: 40px 0;
    position: relative;
    margin-bottom: 20px;

    span {
      background-color: #fff;
      position: absolute;
      z-index: 5;
      display: inline-block;
      padding-right: 20px;
    }
  }

  .h3_title:after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 56px;
    left: 0px;
    width: 100%;
    height: 1px;
    background-color: #d1d1d1;
  }
}

table,
td,
th {
  text-align: center;
  border: 1px solid #cbcbcb;
  border-collapse: collapse;
  line-height: 50px;

  p {
    line-height: 30px;
    margin: 10px 0;
  }
}

table {
  width: 100%;
  margin-bottom: 80px;
}

th {
  background-color: #e5004f;
  color: #fff;
}

td {
  background-color: #fff;
  color: #2d2d2d;
}
.video {
  overflow: hidden;
  margin-bottom: 20px;
  display: flex;
  > div {
    cursor: pointer;
  }
  > div:first-child {
    width: 286px;
    height: 140px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  > div:last-child {
    flex: 1;
    padding-left: 20px;
    > p {
      font-size: 18px;
      color: #000000;
    }
  }
}
.el-button--primary,.el-button--primary:hover,.el-button--primary:active,.el-button--primary:visited{
  border-color: #e5004f !important;
}
.el-button--primary{
  background-color: #e5004f !important;

}
.el-button--primary:hover,.el-button--primary:active,.el-button--primary:visited{
  background-color: #fff !important;
  color:#e5004f;
}
</style>



// WEBPACK FOOTER //
// src/views/center/productDetail.vue